import React, { Suspense, useEffect } from 'react';
import { useGetStandardAnalysisQuery } from '../../../../api/energy-analysis/calculateEnergySavingsApiSlice';
import { Box, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/snackbarSlice';
import StandardAnalysisDatagrid from '@/features/energyxplorer/components/standard-analysis/StandardAnalysisDatagrid';

const StandardAnalysisTab = ({
  selectedAccount,
  selectedEnergyGroup,
  timeRange,
  setTimestampSummary,
  setTimestampSummarySetBy,
}) => {
  const dispatch = useDispatch();

  //Query
  const { data, isFetching, isError } = useGetStandardAnalysisQuery({
    accountId: selectedAccount?.AccountId,
    energyGroupId: selectedEnergyGroup?.energyGroupId,
    start: timeRange?.start,
    end: timeRange?.end,
  });

  useEffect(() => {
    if (isError) {
      dispatch(
        showSnackbar({
          message: 'Standardanalysen kunne ikke vises',
          severity: 'error',
        }),
      );
    }
  }, [dispatch, isError]);

  useEffect(() => {
    if (data?.TimestampsSummary) {
      setTimestampSummary(data.TimestampsSummary);
      setTimestampSummarySetBy('Standardanalysen');
    }
  }, [data, setTimestampSummary, setTimestampSummarySetBy]);

  return (
    <Box sx={{ height: '70vh' }}>
      <Suspense fallback={<CircularProgress />}>
        <StandardAnalysisDatagrid
          initialRows={data?.StandardAnalysisData.map((item) => {
            const energyNode = selectedEnergyGroup?.energyTreeNodes?.find(
              (group) => group.energyTreeNodeId === item.NodeId,
            );
            return {
              ...item,
              id: item.NodeId,
              Name: energyNode?.name,
              Type: energyNode?.type,
              icon: energyNode?.type,
            };
          })}
          isLoading={isFetching}
          selectedEnergyGroup={selectedEnergyGroup.options}
        />
      </Suspense>
    </Box>
  );
};

export default StandardAnalysisTab;
